export const KORTA_PAYMENT_METHOD_TYPE_NAME = 'is_korta_card';
export const VALITOR_PAYMENT_METHOD_TYPE_NAME = 'is_valitor_card';
